var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinerIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 22,
    viewBox: "0 0 9.525 5.8208",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-77.509 -117.13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.18183 .12953)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.119 118.12c0.22462 0 0.47542 0.26872 0.47542 0.65319 0 0.38585-0.2508 0.65457-0.47542 0.65457s-0.47542-0.26872-0.47542-0.65457c0-0.38447 0.2508-0.65319 0.47542-0.65319m0-0.99219c-0.85714 0-1.5517 0.73725-1.5517 1.6454 0 0.9095 0.69453 1.6468 1.5517 1.6468s1.5517-0.73725 1.5517-1.6468c0-0.90813-0.69453-1.6454-1.5517-1.6454z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.306 117.13h-4.6881c-0.8723 0-1.5792 0.93293-1.5792 2.0836v1.87c0 0.44786-0.16123 0.68075-0.51677 1.3767-0.05374 0.11576 0.07166 0.23013 0.25218 0.23013h4.6275c0.19706 0.0138 0.38723-0.0758 0.5016-0.23702 0.25218-0.41203 0.3955-0.88608 0.40652-1.3698v-1.87c-0.02893-0.81442 0.20671-1.6826 0.99632-2.0836z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinerIconW);
export default __webpack_public_path__ + "static/media/liner-icon-w.78d85fd4a61d967de639f0e138639efa.svg";
export { ForwardRef as ReactComponent };